// Vendor identity SDKs must load from their own origins (Google forbids
// bundling/self-hosting GIS; Apple only distributes Sign in with Apple JS via
// its CDN). Each script is appended once and cached as a promise.
const scripts = new Map<string, Promise<void>>();

export const loadScript = (src: string): Promise<void> => {
  let pending = scripts.get(src);
  if (!pending) {
    pending = new Promise((resolve, reject) => {
      const el = document.createElement('script');
      el.src = src;
      el.async = true;
      el.onload = () => resolve();
      el.onerror = () => {
        scripts.delete(src);
        reject(new Error(`Failed to load ${src}`));
      };
      document.head.appendChild(el);
    });
    scripts.set(src, pending);
  }
  return pending;
};
